import { FC } from 'react';

type Props = {
	className?: string;
};

const IdentityCardIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.5998 3.2002H8.39987C5.38294 3.2002 3.87448 3.2002 2.93724 4.13743C2 5.07468 2 6.58313 2 9.60006V10.4C2 13.4169 2 14.9255 2.93724 15.8627C3.87448 16.7999 5.38294 16.7999 8.39987 16.7999H11.5998C14.6167 16.7999 16.1252 16.7999 17.0624 15.8627C17.9997 14.9255 17.9997 13.4169 17.9997 10.4V9.60006C17.9997 6.58313 17.9997 5.07468 17.0624 4.13743C16.1252 3.2002 14.6167 3.2002 11.5998 3.2002Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M4.39844 13.2001C5.22697 11.1352 8.31529 10.9994 9.19834 13.2001'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M8.19838 8.20026C8.19838 8.97345 7.57159 9.60024 6.79841 9.60024C6.02522 9.60024 5.39844 8.97345 5.39844 8.20026C5.39844 7.42708 6.02522 6.80029 6.79841 6.80029C7.57159 6.80029 8.19838 7.42708 8.19838 8.20026Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M11.6016 7.2002H15.6015M11.6016 10.0001H15.6015M11.6016 12.8001H13.6015'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default IdentityCardIcon;
